<template lang="pug">
  .table-responsive(data-testid="exchanger-list")
    table.table.table-striped.table-bordered.bcard-table
      thead
        tr
          th.thd-name 氏名
            template(v-if="sort")
              i.fa.bcard-table-sort-header-icon(v-show="sort.sort_item === 'name'", :class="'fa-sort-' + sort.direction")
          th.thd-group 部署名
            template(v-if="sort")
              i.fa.bcard-table-sort-header-icon(v-show="sort.sort_item === 'dept'", :class="'fa-sort-' + sort.direction")
          th.thd-group 役職
            template(v-if="sort")
              i.fa.bcard-table-sort-header-icon(v-show="sort.sort_item === 'post'", :class="'fa-sort-' + sort.direction")
          th.thd-exchange 初回名刺交換日
            template(v-if="sort")
              i.fa.bcard-table-sort-header-icon(v-show="sort.sort_item === 'first_exchange_date'", :class="'fa-sort-' + sort.direction")
          th.thd-exchange 最終名刺交換日
            template(v-if="sort")
              i.fa.bcard-table-sort-header-icon(v-show="sort.sort_item === 'last_exchange_date'", :class="'fa-sort-' + sort.direction")
          slot(name="thLast")
      tbody
        tr(v-for="(item, index) in list", :key="item.id" :data-testid="item.exchanger_full_name")
          td
            template(v-if="item.user_state === null || item.user_state === '1'")
              | {{item.exchanger_full_name}}
            template(v-else)
              a.text(href="#" @click.prevent="$emit('clickUser', item)") {{item.exchanger_full_name}}
          td {{item.dept}}
          td {{item.post}}
          td {{item.formatted_first_date}}
          td
            router-link(:to="itemLocation(item)" data-testid="-link-last-date") {{item.formatted_last_date}}
          slot(name="tdLast", :item="item")
</template>

<script>
export default {
  name: 'ExchangerList',
  props: {
    value: { type: Array, required: true },
    pCheckedIds: { type: Array, required: true },
    sort: {
      type: Object,
      required: false,
      default () {
        return {
          // ページ条件
          page: { page: 1 },
          // ソート条件
          sort: { sort_item: 'last_exchange_date', direction: 'desc' },
          // 検索条件
          conds: {}
        }
      }
    },
    itemLocation: { type: Function, required: true }
  },
  data () {
    return {
      list: []
    }
  },
  watch: {
    pCheckedIds (pCheckedIds) {
      this.syncCheckedIds(pCheckedIds)
    },
    value (value) {
      this.syncList(value)
    }
  },
  created () {
    this.syncCheckedIds(this.pCheckedIds)
    this.syncList(this.value)
    // this.setMockData()
  },
  methods: {
    syncCheckedIds (checkedIds) {
      this.checkedIds = checkedIds
    },
    syncList (list) {
      this.list = list
    }
  }
}
</script>

<style lang="scss" scoped>
  .thd-name {
    width: 260px;
  }
</style>



// WEBPACK FOOTER //
// src/components/organisms/lists/ExchangerList.vue